import PropTypes from 'prop-types';
import React from 'react';

import { getCompanies } from '../../../services/api/companies';
import CustomTypeahead from '../fields/CustomTypeahead';

class CompanySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
    };

    this._handleCompanySearch = this._handleCompanySearch.bind(this);
    this._handleNewCompany = this._handleNewCompany.bind(this);
  }

  static propTypes = {
    setFieldValue: PropTypes.func,
    name: PropTypes.string,
    filters: PropTypes.object,
  };

  _handleCompanySearch(value) {
    getCompanies({
      ...this.props.filters,
      'filter[name]': value,
    }).then((response) => {
      this.setState({
        companies: response.data,
      });
    });
  }

  _handleNewCompany(values) {
    if (values.length > 0) {
      this.props.setFieldValue(this.props.name, values[0].id);
    } else {
      this.props.setFieldValue(this.props.name, null);
    }
  }

  render() {
    return (
      <CustomTypeahead
        id={this.props.name}
        name={this.props.name}
        label="Company"
        multiple={false}
        options={this.state.companies}
        selected={this.state.defaultCompany?.name}
        placeholder="Choose a company"
        labelKey="name"
        onSearch={this._handleCompanySearch}
        onChange={this._handleNewCompany}
        {...this.props}
      />
    );
  }
}

export default CompanySelector;
